import React, { useState, Fragment } from "react";

import { isEmpty } from "lodash";
import ModalComponent from "../../../components/modalComponent/ModalComponent";

import moment from "moment";
import { PresenceModal } from "./modals/presenceModal";
import { PRESENCE_STATUS_ID, roles } from "./../../../configs/constants";
import ValidateModalContent from "../../../components/presence/ValideModalContent";
import QualifyDayTrips from "./modals/QualifyDayTrips";
import AttendanceBadge from "../components/AttendanceBadge";
import { computePercentage, convertMinutesToString } from "../utils/date.utils";
import { TextDuration } from "../components/TextDuration";
import { ProcessMealPackage } from "./DayView";
import ValidateMealPackagesModal from "./modals/ValidateMealPackages";
import { getNbMealPackages, isAllWeekValidated } from "./presence.utils";
import { Spin } from "antd";
import { get } from "../utils/utils";

const checkIfCanBeQualified = (halfDay = {}) => {
  const isWorkingDay = halfDay.type && halfDay.type.id !== PRESENCE_STATUS_ID.NON_WORK;
  const notValidated = !halfDay.validated;
  const isANX = // Absence non justifié
    halfDay.type && halfDay.type.id === PRESENCE_STATUS_ID.ABSENCE && halfDay.data && halfDay.data.id === "ANX";
  const notProcessedOrIsANX = !halfDay.processed || isANX;
  return isWorkingDay && notValidated; //&& notProcessedOrIsANX;
};
const qualifyWeek = async ({ days, indexWeek, updateAttendance, typeId, subTypeId }) => {
  for (let i = 0; i < days.length; i++) {
    const day = days[i];
    const attendance = day.attendances;
    const afternoon = attendance.afternoon || {};
    const morning = attendance.morning || {};
    if (checkIfCanBeQualified(morning)) {
      let paramsMorning = {
        _id: morning._id,
        type: { id: typeId },
        index: indexWeek,
        data: { id: subTypeId },
        dayIndex: i
      };

      await updateAttendance(paramsMorning);
    }
    if (checkIfCanBeQualified(afternoon)) {
      const paramsAfternoon = {
        _id: afternoon._id,
        type: { id: typeId },
        index: indexWeek,
        data: { id: subTypeId },
        dayIndex: i
      };
      await updateAttendance(paramsAfternoon);
    }
  }
};
const computeDurationsOfWeek = data => {
  const days = data.data || [];
  const durations = days.map(day => day.durations);
  const attendance =
    durations &&
    durations.reduce((acc, cur) => {
      return acc + cur.attendance;
    }, 0);
  const activity = durations.reduce((acc, cur) => acc + cur.activity, 0);
  const trips = durations.reduce((acc, cur) => acc + parseInt(cur.trips), 0);

  return { activity, trips, attendance };
};
const BadgeTrips = ({ data, onClick }) => {
  const validated = !data.some(trip => !trip.validated);
  const nbPro = data.filter(trip => trip.type.id === 1).length;
  const nbPerso = data.filter(trip => trip.type.id !== 1).length;
  let classes = "rounded-full p-2 w-full h-8 my-1 border-2 text-center ";
  classes += validated ? "border-green-400 text-white bg-green-400 " : "bg-gray-200 text-black border-black ";

  return (
    <div
      style={{ width: "135px" }}
      className={`${classes} ${nbPro + nbPerso > 0 ? " cursor-pointer" : ""}`}
      onClick={onClick}
    >
      {nbPro} pro / {nbPerso} perso
    </div>
  );
};

const BadgeMealPackage = ({ day, onClick }) => {
  let classes = "rounded-full p-2 w-full h-8 my-1 border-2 text-center cursor-pointer";

  if (day.meal_packages && day.meal_packages[0]) {
    if (day.meal_packages[0].granted === true) {
      classes += " border-green-400";
    } else if (day.meal_packages[0].granted === false) classes += " border-red-500";
    if (day.meal_packages[0].validated === true) {
      if (day.meal_packages[0].granted === true) {
        classes += " bg-green-400 text-white";
      } else classes += " bg-red-500 text-white";
    } else classes += ` ${day.meal_packages[0].granted ? " text-green-400" : " text-red-400"}`;
  }

  return (
    <div style={{ width: "135px" }} className={`${classes} cursor-pointer`} onClick={onClick}>
      {day.meal_packages && day.meal_packages[0] && day.meal_packages[0].warning && "⚠️"} Forfait repas{" "}
      {day.meal_packages && day.meal_packages[0] && day.meal_packages[0].warning && "⚠️"}
    </div>
  );
};

const QuickValidationLink = ({ duration, label, onClick, durationTotal }) => {
  return (
    <div className="flex">
      <span className="my-1 text-orange-500 underline cursor-pointer" onClick={onClick}>
        {label}
      </span>
      <span className="my-1 mx-2 text-gray-900 font-bold">
        {duration && `${computePercentage(duration, durationTotal)} (${convertMinutesToString(duration)})`}
      </span>
    </div>
  );
};
const QuickValidationMealPackageLink = ({ nb, label, onClick }) => {
  return (
    <div className="flex">
      <span className="my-1 text-orange-500 underline cursor-pointer" onClick={onClick}>
        {label}
      </span>
      <span className="my-1 mx-2 text-gray-900 font-bold">{nb}</span>
    </div>
  );
};
const QuickValidationPresenceLink = ({ duration, label, onClick, disabled = false }) => {
  return (
    <div className="flex">
      {disabled ? (
        <span className="my-1 text-gray-500">{label}</span>
      ) : (
        <span className="my-1 text-orange-500 underline cursor-pointer" onClick={onClick}>
          {label}
        </span>
      )}
      <span className="my-1 mx-2 text-gray-900 font-bold">{duration}</span>
    </div>
  );
};
export const WeekRow = ({
  updateTrip,
  updateMealPackage,
  updateAttendance,
  isBtnValidatePresenceDisplayed,
  indexWeek,
  userDetailsRole,
  errorMsg,
  userRoleId,
  setDidErrorOccured,
  didErrorOccured,
  handleValidateMealPackages,
  mealPackageModalValue,
  setMealPackageModalValue,
  weekData = {},
  onClick,
  absenceTypes,
  token,
  accept,
  reject,
  fetchData,
  userId,
  rangeDate,
  weekIsLoading
}) => {
  let daysMissing = 0;
  let daysBefore = 0;

  if (weekData.data && weekData.data.length !== 7) {
    const firstDay = moment(weekData.data[0].date_iso).day();

    daysMissing = 7 - weekData.data.length;
    if (firstDay !== 1) daysBefore = -1;
    else daysBefore = 1;
  }

  let durations = computeDurationsOfWeek(weekData);
  let nbMealPackages = getNbMealPackages(weekData);
  const [isMealPackageValidationModalOpen, setIsMealPackageValidationModalOpen] = useState(false);
  const days = weekData.data || [];

  const [mealPackageSelected, setMealPackageSelected] = useState(null);
  const handleGrantMealPackage = async (onCloseModal, dayIndex) => {
    const payload = {
      _id: mealPackageSelected && mealPackageSelected[0] && mealPackageSelected[0]._id,
      granted: mealPackageModalValue,
      index: indexWeek,
      indexWeek: indexWeek,
      dayIndex: dayIndex,
      validated: mealPackageSelected && mealPackageSelected[0] && mealPackageSelected[0].validated,
      user_id: userId,
      warning: mealPackageSelected && mealPackageSelected[0] && mealPackageSelected[0].warning
    };
    if (Array.isArray(rangeDate) && rangeDate.length === 2) {
      const startDate = rangeDate[0];
      const endDate = rangeDate[1];
      payload.start_date = startDate;
      payload.end_date = endDate;
    }
    updateMealPackage(payload);

    onCloseModal(false);
  };

  const isMealPackagesBtnDisplayed = () => {
    const mealPackagesNotEmpty = weekData.data.find(
      dataItem =>
        dataItem.meal_packages &&
        !isEmpty(dataItem.meal_packages) &&
        moment(dataItem.date_iso).isBefore(moment(), "day")
    );

    if (moment(weekData.start_date).isSameOrAfter(moment())) return false;

    return mealPackagesNotEmpty && userDetailsRole === roles.TERRAIN && userRoleId < 4;
  };

  return (
    <Fragment>
      <ValidateMealPackagesModal
        isModalOpen={isMealPackageValidationModalOpen}
        onCloseModal={() => setIsMealPackageValidationModalOpen(false)}
        onValidate={() => handleValidateMealPackages(weekData, indexWeek, setIsMealPackageValidationModalOpen)}
        weekData={weekData}
      />
      <tr
        className={`hover:bg-gray-100 text-gray-700 text-lg ${
          moment(weekData.start_date).isSame(moment(), "week") ? "bg-red-200" : ""
        }`}
        key={weekData.week}
      >
        <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500">
          <div>{weekData.weekLabel}</div>
          {/* {!isAllWeekValidated(days) && (
            <Fragment>
              <div
                className="my-1 text-orange-500 underline cursor-pointer"
                onClick={async () => {
                  await qualifyWeek({ days, indexWeek, updateAttendance, typeId: PRESENCE_STATUS_ID.ATTENDANCE });
                  // fetchData({ _startDate: moment(weekData.start_date), _endDate: moment(weekData.start_date) });
                }}
              >
                passer la semaine en présence
              </div>
              <div
                className="my-1 text-orange-500 underline cursor-pointer"
                onClick={async () => {
                  await qualifyWeek({
                    days,
                    indexWeek,
                    updateAttendance,
                    typeId: PRESENCE_STATUS_ID.ABSENCE,
                    subTypeId: "ANX"
                  });
                  // fetchData({ _startDate: moment(weekData.start_date), _endDate: moment(weekData.start_date) });
                }}
              >
                passer la semaine en absence injustifiée
              </div>
            </Fragment>
          )} */}
        </td>
        <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5">
          <TextDuration
            label="Activité"
            duration={durations.activity}
            durationTotal={durations.activity + durations.trips}
          />
          <QuickValidationLink
            duration={durations.trips}
            durationTotal={durations.trips + durations.activity}
            label="Valider les trajets"
            onClick={() => {
              onClick("validateTrips");
            }}
          />
          {/* {isBtnValidatePresenceDisplayed && (
            <QuickValidationPresenceLink
              disabled={false}
              duration={durations.attendance}
              label="Valider les présences"
              onClick={() => {
                onClick("validateAttendance");
              }}
            />
          )} */}
          {userRoleId < 4 && isMealPackagesBtnDisplayed() && (
            <QuickValidationMealPackageLink
              nb={nbMealPackages}
              label="Valider les forfaits repas"
              onClick={() => {
                setIsMealPackageValidationModalOpen(true);
              }}
            />
          )}
          <div className="flex">
            <span className="my-2 text-lg text-gray-700">Global : </span>
            <span className="my-2 mx-2 text-lg text-gray-700 font-bold">
              {convertMinutesToString(durations.activity + durations.trips)}
            </span>
          </div>
          <div className="flex">
            <span className="my-2 text-lg text-gray-700">Temps effectif : </span>
            <span className="my-2 mx-2 text-lg text-gray-700 font-bold">
              {convertMinutesToString(weekData.durations && Math.round(weekData.durations.working_duration).toFixed(2))}
            </span>
          </div>
        </td>

        <Fragment>
          {daysMissing !== 0 &&
            daysBefore === -1 &&
            Array.from({ length: daysMissing }).map((_, i) => {
              return (
                <td
                  key={i}
                  style={{ width: "180px" }}
                  className={`p-10 whitespace-no-wrap border-b border-gray-200 leading-5`}
                />
              );
            })}
          {days.map((day, dayIndex) => {
            const [modalOpen, setModalOpen] = useState(false);
            const [modalAttendanceOpen, setModalAttendanceOpen] = useState(false);
            const [modalType, setModalType] = useState({ type: "attendance" });
            const mealPackageWarning = get(["meal_packages", 0, "warning"], day, false);

            return (
              <Fragment key={day.date + weekData.week}>
                {!weekIsLoading ? (
                  <td
                    className={`
                  p-6 whitespace-no-wrap border-b border-gray-200 leading-5 ${
                    moment(day.date).isSame(moment(), "day") ? "bg-red-300" : ""
                  }`}
                  >
                    <BadgeTrips
                      data={day.trips}
                      onClick={() => {
                        setModalType({ type: "trip", dayIndex: dayIndex });
                        setModalOpen(true);
                      }}
                    />
                    {/* <AttendanceBadge
                      dayIndex={dayIndex}
                      day={day}
                      period={"morning"}
                      setModalOpen={setModalOpen}
                      setModalAttendanceOpen={setModalAttendanceOpen}
                      setModalType={setModalType}
                    />
                    <AttendanceBadge
                      dayIndex={dayIndex}
                      day={day}
                      period={"afternoon"}
                      setModalOpen={setModalOpen}
                      setModalAttendanceOpen={setModalAttendanceOpen}
                      setModalType={setModalType}
                    /> */}
                    {isMealPackagesBtnDisplayed() && (
                      <BadgeMealPackage
                        day={day}
                        onClick={() => {
                          if (userRoleId < 4) {
                            setMealPackageModalValue(
                              day.meal_packages && day.meal_packages[0] ? day.meal_packages[0].granted : false
                            );
                            setMealPackageSelected(day.meal_packages);
                            setModalType({
                              type: "mealpackage",
                              dayIndex: dayIndex,
                              content: day.meal_packages && day.meal_packages[0]
                            });
                            setModalOpen(true);
                          }
                        }}
                      />
                    )}
                    <div className="leading-5 text-gray-500 text-center">{moment(day.date_iso).format("DD/MM")}</div>
                  </td>
                ) : (
                  dayIndex === 0 && (
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 100
                      }}
                    >
                      <Spin />
                    </div>
                  )
                )}
                <ModalComponent
                  title={`Qualifier la journée du ${day.date} (présence)`}
                  width={500}
                  showModal={modalAttendanceOpen}
                  closeModal={() => {
                    setDidErrorOccured(false);
                    setModalAttendanceOpen(false);
                  }}
                >
                  {modalType.type === "attendance" && (
                    <PresenceModal
                      indexSelected={indexWeek}
                      dayIndex={modalType.dayIndex}
                      updateAttendance={updateAttendance}
                      userRoleId={userRoleId}
                      absenceTypes={absenceTypes}
                      token={token}
                      attendance={day.attendances}
                      visits={day.visits}
                      closeModal={() => {
                        setModalAttendanceOpen(false);
                      }}
                    />
                  )}
                </ModalComponent>
                <ModalComponent
                  title={
                    modalType.type === "pending"
                      ? "Demande de congé"
                      : `Qualifier la journée du ${day.date} (${modalType.type === "trip" ? "trajet" : "repas"})`
                  }
                  width={modalType.type === "trip" ? 1000 : 500}
                  showModal={modalOpen}
                  closeModal={() => {
                    setDidErrorOccured(false);
                    if (modalType.type !== "trip") {
                      setModalOpen(false);
                    }
                  }}
                  closable={modalType.type !== "trip"}
                >
                  {modalType.type === "pending" && (
                    <ValidateModalContent
                      eventInfos={modalType.payload}
                      accept={vacation => {
                        accept({ vacation: { _id: vacation._id } });
                        fetchData();
                      }}
                      reject={vacation => {
                        reject({ vacation: { _id: vacation._id } });
                        fetchData();
                      }}
                      closeModal={() => {
                        setModalOpen(false);
                      }}
                    />
                  )}
                  {modalType.type === "trip" && (
                    <QualifyDayTrips
                      indexSelected={indexWeek}
                      dayIndex={modalType.dayIndex}
                      updateTrip={updateTrip}
                      token={token}
                      day={day}
                      closeModal={() => {
                        setModalOpen(false);
                      }}
                      fetchData={fetchData}
                    />
                  )}
                  {modalType.type === "mealpackage" && (
                    <ProcessMealPackage
                      indexSelected={indexWeek}
                      displayTitle={true}
                      didErrorOccured={didErrorOccured}
                      errorMsg={errorMsg}
                      warning={mealPackageWarning}
                      mealPackageModalValue={mealPackageModalValue}
                      setMealPackageModalValue={setMealPackageModalValue}
                      handleGrantMealPackage={() => handleGrantMealPackage(() => setModalOpen(false), dayIndex)}
                      closeModal={() => {
                        setModalOpen(false);
                      }}
                    />
                  )}
                </ModalComponent>
              </Fragment>
            );
          })}
          {daysMissing !== 0 &&
            daysBefore === 1 &&
            Array.from({ length: daysMissing }).map((_, i) => {
              return (
                <td
                  key={i}
                  style={{ width: "180px" }}
                  className={`p-10 whitespace-no-wrap border-b border-gray-200 leading-5`}
                />
              );
            })}
        </Fragment>
      </tr>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/presence/WeekRow.js